import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHospitality = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      d="M18.186 10.184a2.716 2.716 0 0 1-3.333 2.64v1.519a.22.22 0 0 1-.44 0v-3.56a.22.22 0 0 1 .44 0v1.585q.303.087.62.088a2.275 2.275 0 0 0 2.272-2.272 2.271 2.271 0 0 0-4.156-1.27.22.22 0 0 1-.366-.248c.378-.56.943-.95 1.582-1.112a3.36 3.36 0 0 0-3.12-2.113 3.366 3.366 0 0 0-3.363 3.362.22.22 0 0 1-.44 0q0-.451.102-.874-.135-.017-.27-.018a2.275 2.275 0 0 0-2.273 2.273 2.275 2.275 0 0 0 3.414 1.964.22.22 0 1 1 .222.381 3 3 0 0 1-.401.19v4.295c0 .409.33.743.738.745h4.256a.74.74 0 0 0 .743-.745.22.22 0 0 1 .44 0c0 .319-.124.618-.35.842a1.17 1.17 0 0 1-.832.344H9.413a1.187 1.187 0 0 1-1.178-1.186v-4.168q-.257.05-.522.05A2.716 2.716 0 0 1 5 10.184a2.716 2.716 0 0 1 3.11-2.682A3.81 3.81 0 0 1 11.686 5c1.597 0 3.012.992 3.563 2.48q.113-.01.225-.01a2.716 2.716 0 0 1 2.713 2.714m-8.18 4.516v1.686a.22.22 0 0 0 .442 0V14.7a.22.22 0 0 0-.441 0m1.467 0v1.686a.22.22 0 0 0 .441 0V14.7a.22.22 0 0 0-.44 0m1.467 0v1.686a.22.22 0 0 0 .44 0V14.7a.22.22 0 0 0-.44 0"
    />
  </svg>
);
export default SvgHospitality;
